import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { AppComponent } from './src/app.component';
import { GlobalErrorHandler } from './src/services/global-error-handler';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
});
